import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import Panel from 'wonderbly-components/lib/Panel';
import Loading from '../Loading';
import RichText from '../Prismic/RichText';
import './VerifyPayment.scss';

const VerifyPayment = props => {
  if (props.complete || typeof(props.complete) === 'undefined' || isEmpty(props.content) || props.content[0].text.length === 0) {
    return null;
  }
  return (
    <section className="verify-payment">
      <div className="container-guttered">
        <Panel border="shadow">
          <RichText fields={props.content} />
          <Loading className="verifying" relative small dark />
        </Panel>
      </div>
    </section>
  );
};

VerifyPayment.propTypes = {
  complete: PropTypes.bool,
  content: PropTypes.array,
};

export default VerifyPayment;



// WEBPACK FOOTER //
// ./src/client/js/view/components/VerifyPayment/VerifyPayment.js